export const pagerDutyRoutingServiceKeyRegex = new RegExp('^[0-9a-zA-Z]{32}$')
